









































































































































































































































































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import UserService from '@/services/UserService'
import FormatDate from '@/helpers/FormatDate'
import GroupChatService from '@/services/GroupChatService'
import linkifyHtml from 'linkify-html'
import { handleMemberLoginStatus } from '@/helpers/Common'
import GroupMemberService from '@/services/GroupMemberService'
import { ERR_API_KEY } from '@/constants'
import { VeeValidateObserverRef } from '@/models/Common/Validation'

@Component
export default class ModalShowProfile extends Vue {
  @Prop({ default: 'modal-show-profile' }) id!: string
  @Prop() userId!: number
  user_info: any = {}
  user_personal_info: any = {}
  avatar_default: any = require('@/assets/images/avatar-default.png')
  date_of_birth: any = ''
  current_user: number = this.$store.state.userInfo.user.info.id
  isShow: boolean = false
  employeeNumberData = {
    raw: '',
    value: ''
  }
  infoMess: string = ''
  successMess: string = ''
  isCreatingChat: boolean = false
  $refs!: {
    observer: VeeValidateObserverRef
  }

  @Watch('userId')
  getUserProfile() {
    if (this.userId === -1) {
      this.user_info = {}
      this.user_personal_info = {}
    } else {
      this.getUserProfileById()
      this.getUserPersonalInfoById()
    }
  }

  handleShow() {
    this.isShow = false
  }

  handleHidden() {
    this.employeeNumberData.value = this.employeeNumberData.raw
  }

  getUserPersonalInfoById() {
    UserService.getUserPersonalInfoById(this.userId).then(response => {
      if (response.status === 200) {
        this.user_personal_info = response.data
        if (
          this.user_personal_info.birthday_year &&
          this.user_personal_info.birthday_month &&
          this.user_personal_info.birthday_day
        ) {
          this.date_of_birth =
            this.user_personal_info.birthday_year +
            '/' +
            this.user_personal_info.birthday_month +
            '/' +
            this.user_personal_info.birthday_day
        } else {
          this.date_of_birth = ''
        }
      }
    })
  }

  formatDateWithoutDays(date: string) {
    if (date === '') {return null} else {
      return FormatDate.formatDateWithoutDays(date)
    }
  }

  getUserProfileById() {
    this.isShow = true
    UserService.getUserProfileById(this.userId)
      .then(response => {
        if (response.status === 200) {
          this.user_info = response.data
          this.employeeNumberData = {
            raw: this.user_info.employee_number,
            value: this.user_info.employee_number
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => (this.isShow = false))
  }

  handleLoginStatus() {
    return handleMemberLoginStatus({
      lastLoginAt: this.user_info?.last_login_at,
      tobeLoggedOut: this.user_info?.to_be_logged_out,
      isCurrentUser: this.userId === this.$store.state.userInfo.user.info.id
    })
  }

  hideModal() {
    this.$bvModal.hide(this.id)
  }

  /**
   * Check create group chat 2 member
   * Chatted in history ? comeback old group : create new group chat
   */
  async checkGroupChatExist(user_id: number) {
    if (this.isCreatingChat) return
    this.isCreatingChat = true
    try {
      const res = await GroupChatService.getGroupChatExist(user_id)
      if (res.status === 200) {
        if (res.data.is_existed === true) {
          const group_chat_id = res.data.group_chat.id
          const revertRes = await GroupChatService.revertOriginMember(group_chat_id)
          if (revertRes.status === 200) {
            this.$router.push({
              name: 'chat-detail',
              params: { groupChatId: group_chat_id }
            })
            this.$bvModal.hide('modal-show-profile')
          }
        } else {
          await this.createNewGroupChat()
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      this.isCreatingChat = false
    }
  }

  /**
   * Create new group chat with user in modal show profile
   */
  async createNewGroupChat() {
    const data = {
      user_ids: this.userId.toString(),
      sender_id: this.$store.state.userInfo.user.profile.user_id,
      last_message: '',
      size: 0,
      last_message_special: false,
      only_user: true,
      name: this.user_info.name + this.$t('common.suffix.san'),
      group_id: this.$route.params.groupId
    }
    const res = await GroupChatService.createNewGroupChat(data)
    if (res.status === 201) {
      await GroupChatService.revertOriginMember(res.data.id)
      this.$router.push({
        name: 'chat-detail',
        params: { groupChatId: `${res.data.id}` }
      })
    }
  }

  handleLinkifyContent(content: string) {
    return linkifyHtml(content || '', { target: '_blank' })
  }

  onUpdateEmployeeNumber() {
    this.$refs.observer.validate().then(async isValidate => {
      if (isValidate) {
        this.$blockui.show()

        try {
          const payload = {
            user_id: this.userId,
            employee_number: this.employeeNumberData.value
          }

          await GroupMemberService.updateEmployeeNumberByAdmin(
            this.$route.params.groupId,
            payload
          )

          this.employeeNumberData.raw = this.employeeNumberData.value

          this.successMess = this.$t(
            'common.message.updated_employee_number'
          ) as string
          this.$bvModal.show('modal-success')
        } catch (error: any) {
          const message = error.response?.data?.message
          const status = error.response?.status
          if (status === 403) {
            if (message === ERR_API_KEY.USE_HAS_BEEN_UPDATED) {
              this.infoMess = this.$t(
                'common.message.topic_edited_by_other'
              ) as string
            } else {
              this.infoMess = this.$t(
                'common.message.update_employee_number_denied'
              ) as string
            }
          } else {
            this.infoMess = this.$t(
              'common.message.something_went_wrong'
            ) as string
          }
          this.$bvModal.show('modal-info')
        } finally {
          this.$blockui.hide()
        }
      } else {
        return
      }
    })
  }
}
